// focus.js
export const focusDirective = {
  // 当绑定元素插入到 DOM 中时调用
  mounted(el) {
    el.focus(); // 聚焦
  }
};
